<template>
  <div class="search-bar">
    <input
      type="search"
      class="form-control"
      placeholder="Search your task here..."
      aria-label="Search"
      v-model="searchQuery"
      @input="onInput"
    />
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      searchQuery: "", // 绑定输入框的内容
    };
  },
  methods: {
    onInput() {
      // 当用户输入时触发，可以在这里添加逻辑，例如过滤列表或发送请求
      this.$emit("update:search", this.searchQuery);
    },
  },
};
</script>

<style scoped>
.form-control:focus {
  border-color: #ae76ff; /* 设置焦点时边框颜色为紫色 */
  box-shadow: 0 0 0 0.1rem #702dff; /* 设置焦点时的阴影颜色 */
}
</style>
